import { getFunctions, httpsCallable } from "@firebase/functions";
import useSWR from "swr";
import { firebaseApp } from "../../../firebase/firebaseClient";
import {
  AveragePrepFqScores,
  IncomingAvgScores,
  PrepFqProfile,
  User,
} from "../../../models/users";
import { calculateAge } from "../../../utils/date";

const fetcher = async (url: string, scaled_score, date_of_birth, gender) => {
  const functions = getFunctions(firebaseApp);
  const onGetAvgPrepFqScores = httpsCallable(functions, "onGetAvgPrepFqScores");
  const avgScoresSnap = await onGetAvgPrepFqScores({
    age: calculateAge(date_of_birth),
    gender: gender,
    scaled_score: scaled_score,
    private_key: process.env.NEXT_PREP_FQ_SCORING_KEY,
  } as IncomingAvgScores);
  return avgScoresSnap;
};

function useAveragePrepFqScores(
  profileId?: string,
  user?: User,
  profile?: PrepFqProfile
) {
  const { data, mutate, error } = useSWR(
    [
      profileId && profile && user ? `/prepFq/avgScores` : null,
      profile?.results?.scaled_score,
      user?.date_of_birth,
      user?.gender,
    ],
    fetcher
  );
  const result: {
    avgScores: AveragePrepFqScores;
    isLoading: boolean;
    isError: boolean;
    mutate: any;
  } = {
    avgScores: data?.data as any,
    isLoading: !error && !data?.data,
    isError: error,
    mutate,
  };
  return result;
}

export default useAveragePrepFqScores;
